<template>
    <Button :size="size" :type="getType(A)" class="btn" @click="click" v-if="$A[A]"
        :custom-icon="getIocn(A)">{{ getTitle(A) }}</Button>
</template>

<script>

export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
            values: [],
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        A: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: "small"
        },
        icon: {
            type: String,
            default: ""
        }
    },


    // +----------------------------------------------------------------------
    // | Desc:methods
    // +----------------------------------------------------------------------
    methods: {
        click(A) {
            this.$emit('Tap', this.values);
        },
        getType(A) {
            if (!this.$isblank(this.type)) {
                return this.type;
            };
            var color = this.$A[A]['color']
            if (!this.$isblank(color)) {
                return color;
            };

            return 'default';
        },
        getTitle(A) {
            if (!this.$isblank(this.title)) {
                return this.title;
            };

            var title = this.$A[A]['title']
            if (!this.$isblank(title)) {
                return title;
            };

            return '按钮';
        },
        getIocn(A) {
            if (!this.$isblank(this.icon)) {
                return this.icon;
            };

            var icon = this.$A[A]['icon']
            if (!this.$isblank(icon)) {
                return icon;
            };
            return '';
        }
    }
}
</script>